import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdownTrigger = function (props) {
    var isActive = props.isActive, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-trigger-v2", { ref: ref, "is-active": [true, false].includes(isActive) ? (isActive ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentsSidebarV2FilterDropdownTrigger;
